import rosterService from './roster';
import { getAllAssessmentsForStudents } from "../../../services/API";
import actions from '../state/benchmark/actions';
import types from '../state/benchmark/constants';
import cloneDeep from 'lodash.clonedeep';
import { getUserData } from '../../../services/API';
import {getScreeningWindowsForSchoolYear} from "Services/screeningWindowService";

/*
Fetches benchmark activities.

TODO: evaulate whether, medium term, tracking/benchmark activities will be identical
*/

export const fetchActivities = (classroomId, equating, locale, window, cachedBenchmarkData, dispatch) => {
  return rosterService.fetchRoster('student',classroomId, cachedBenchmarkData).then((students) => {
    dispatch(actions[types.BENCHMARK_CACHE_SAVE]({
      classroomId,
      updateKey: 'students',
      'students': students,
    }))

    // TODO refactor so that this error handling is encapsulated, across benchmark/tracking/activities
    if(!Array.isArray(students) || students.length == 0) {
      return [];
    }

    let { startDate, endDate } = window

    if(getUserData().demoLockdown){
      const windows = getScreeningWindowsForSchoolYear();
      startDate = windows.find(option=>option.id === "BOY").startDate;
      endDate = windows.find(option=>option.id === "EOY").endDate;
    }

    const type = ["assessment"]
    const limit = 30
    const cachedActivitiesKey = `activities_${equating ? 'equated': 'not_equated'}_${locale ? locale : 'default'}_${window.id}`
    const cachedActivitiesData = cachedBenchmarkData && cachedBenchmarkData[cachedActivitiesKey]

    if(cachedActivitiesData) return cachedActivitiesData

    return getAllAssessmentsForStudents(students, limit, type, equating, locale, startDate, endDate).then((activities) => {
      dispatch(actions[types.BENCHMARK_CACHE_SAVE]({
        classroomId,
        updateKey: cachedActivitiesKey,
        [cachedActivitiesKey]: cloneDeep(activities),
      }))
      return activities;
    }, (error) => {
      console.log(error);
    });
  }, (error) => {
      console.log(error);
  });
}

export default {
  fetchActivities,
}